// ------------------------------------
// Catálogo
// ------------------------------------

(function () {
  'use strict';

  // Variáveis
  const $listaCatalogo = $('#catalogo-lista');
  const $catLoading = $('#catalogo-spinner');
  let catalogoInfos;
  if ($listaCatalogo.length > 0) {
    getCatalogo();
    $listaCatalogo.on('reload-catalogo', getCatalogo);
  }

  // Obtém a lista de catálogo
  function getCatalogo() {
    $listaCatalogo.html('');
    $catLoading.removeClass('d-none');
    catalogoInfos = $listaCatalogo.data('catalogo');
    if (!catalogoInfos) {
      catalogoInfos = [];
    }
    if (typeof catalogoInfos === 'string') {
      catalogoInfos = JSON.parse(catalogoInfos);
    }
    catalogoInfos = catalogoInfos.filter((item) => item.status == 1);
    const lpsIDsArr = catalogoInfos.map((item) => item.lp_id);
    const lpsIDs = lpsIDsArr.join('-');
    let urlAPI = urlBase + 'core/acoes/themes/booster/catalogo.php?store_token=' + publicToken + '&ids=' + lpsIDs;
    if (lpsIDsArr.length > 0) {
      let previewTemplate = false;
      const $previewTemplateProds = $('#catalogo-lista-preview');
      let previewTemplateProds = [];
      if ($previewTemplateProds.length > 0) {
        previewTemplate = true;
        previewTemplateProds = JSON.parse($previewTemplateProds.val());
      }
      if (!previewTemplate) {
        $.getJSON(urlAPI, function (resp) {
          //console.log(resp);
          if (resp.status == 'success') {
            const produtos = mergeCatalogoInfos(resp.result);
            populaCatalogo(produtos);
          } else {
            console.log('Nenhum produto encontrado para o catálogo.');
            $catLoading.addClass('d-none');
          }
        }).fail(function () {
          console.log(arguments);
          $catLoading.addClass('d-none');
        });
      } else {
        const produtos = mergeCatalogoInfos(previewTemplateProds);
        populaCatalogo(produtos);
      }
    } else {
      $catLoading.addClass('d-none');
    }
  }

  // Formata a lista de produtos vindo da API com os elementos cadastrados no editor
  function mergeCatalogoInfos(produtos) {
    return produtos.map((produto) => {
      const moreInfos = catalogoInfos.filter((item) => item.lp_id == produto.lp_id)[0];
      return {
        ...produto,
        ...moreInfos,
      };
    });
  }

  // Popula lista catálogo
  function populaCatalogo(lista) {
    $listaCatalogo.html('');
    // Ordena a lista corretamente com base no atributo 'ordem'
    lista = lista.sort(function (a, b) {
      return parseFloat(a['ordem']) - parseFloat(b['ordem']);
    });
    lista.forEach((produto) => {
      let $flag = '';
      if (produto['flag-show'] == 1 && produto['flag-text']) {
        $flag = `<span class="cat-prod-flag ${produto['flag-position']}">${produto['flag-text']}</span>`;
      }
      let $stars = '';
      if (produto.stars > 1) {
        $stars = `<div class="star-rating cat-prod-stars">`;
        for (let i = 1; i <= 5; i++) {
          const activeStar = parseInt(produto.stars) >= i ? 'active' : '';
          $stars =
            $stars +
            `<label class="${activeStar}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"/></svg></label>`;
        }
        $stars += '</div>';
      }
      let $priceOld = '';
      if (Number(produto.old_price) > 0) {
        $priceOld = `<span class="old">R$ ${formatMoneyBR(produto.old_price)}</span>`;
      }
      let $parcTxt = '';
      if (produto.parcelamento) {
        $parcTxt = `<div class="cat-prod-parc">${mdParse(produto.parcelamento, true)}</div>`;
      }
      $listaCatalogo.append(`
      <a href="${produto.url}" class="grid-3 grid-md-4 grid-sm-6 grid-xs-6 cat-prod-wrp">
        <div class="cat-prod">
          <figure class="img cat-prod-img">
            <img class="shimmer lazyload" data-src="${getThumb(produto.thumb_md)}" src="${imgLazy(
        300,
        300,
      )}" width="100%" height="300px" alt="${produto.title}">
            ${$flag}
          </figure>
          <div class="cat-prod-infos">
            ${$stars}
            <div class="cat-prod-title">${produto.title}</div>
            <div class="cat-prod-price">
              ${$priceOld}
              <span class="new">R$ ${formatMoneyBR(produto.sale_price)}</span>
            </div>
            ${$parcTxt}
          </div>
        </div>
      </a>`);
    });
    $catLoading.addClass('d-none');
  }
})();
